module.exports = __webpack_public_path__ + "static/media/anc1ru.58eebb1e.pdf";